const SELECTOR = 'iframe[data-src]';

// Generous lead time: these embeds autostart, and a heavy one needs a head start to be
// running by the time it scrolls into view. Still far enough down not to touch page load.
const ROOT_MARGIN = '800px';

/**
 * Native loading="lazy" on iframes uses a very generous distance threshold, so heavy
 * third-party embeds still download on a page the visitor never scrolls through. Holding
 * the URL in data-src and swapping it in close to the viewport keeps them out of the
 * initial load.
 */
function load(iframe) {
  const src = iframe.dataset.src;
  if (!src) return;

  delete iframe.dataset.src;
  iframe.src = src;
}

function observe(iframes) {
  if (!('IntersectionObserver' in window)) {
    iframes.forEach(load);
    return;
  }

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        load(entry.target);
        observer.unobserve(entry.target);
      });
    },
    { rootMargin: ROOT_MARGIN }
  );

  iframes.forEach((iframe) => observer.observe(iframe));
}

function collect(root) {
  return Array.from(root.querySelectorAll(SELECTOR));
}

function init(root) {
  const iframes = collect(root);
  if (iframes.length) observe(iframes);
}

init(document);

document.addEventListener('shopify:section:load', (event) => init(event.target));
